import React, { useContext, useEffect, forwardRef, ForwardRefRenderFunction } from 'react';
import classNames from 'classnames';

import IToast from 'common/types/IToast';

import UiContext from 'common/UiContext/UiContext';

import './toast.scss';
import Icons from 'assets/images/Icons';
import iconsIndex from 'assets/images/Icons/iconsIndex';

const Toast: ForwardRefRenderFunction<HTMLDivElement, IToast> = ({ id, message, type }, ref) => {
  const { removeToast } = useContext(UiContext);

  useEffect(() => {
    const toastLifetime = setTimeout(() => {
      if(removeToast){
        removeToast(id);
      }
    }, 3000);

    return () => {
      clearTimeout(toastLifetime);
    };
  }, []);

  return (
    <div className={classNames({
      toast: true,
      [type as string]: true,
    })}
    ref={ref}
    >
      <div className='toastIcon'>
        <Icons name={type as keyof typeof iconsIndex ?? 'Check'} />
      </div>
      <div className='message'>{message}</div>
      <div className='closeToast' onClick={() => {
        removeToast!(id);
      }}>
        <Icons name='Cancel' />
      </div>
    </div>
  );
};

export default forwardRef<HTMLDivElement, IToast>(Toast);